import MessageDescriptor from '../MessageDescriptor.js';
import BaseField from './BaseField.js';
class MessageField extends BaseField {
    message;
    messageName;
    constructor(data) {
        const descriptor = MessageDescriptor.load(data.message);
        super({
            ...data,
        });
        this.message = data.message;
        this.messageName = data.message.name;
        this.references = [descriptor];
        this.proto.type = this.messageName;
    }
    getExample(transport) {
        return MessageDescriptor.load(this.message).getExample(transport);
    }
    toSchema() {
        return {
            $ref: `#/components/schemas/${this.messageName}`,
        };
    }
    toJSON(input, target) {
        return input.toJSON(target);
    }
    fromJSON(input) {
        if (typeof input === 'undefined' || this.message.isInstance(input)) {
            return input;
        }
        return this.message.create(input);
    }
    fromProto(input) {
        if (typeof input === 'undefined' || this.message.isInstance(input)) {
            return input;
        }
        return this.message.fromProto(input);
    }
}
export default MessageField;
//# sourceMappingURL=MessageField.js.map